module.exports = __webpack_public_path__ + "static/ReviewUpload_imgs-3db3a2c4e0c900cd5ee52a3191eb4353.png";